import { render, staticRenderFns } from "./TrialHeader.vue?vue&type=template&id=661d4b94&scoped=true"
import script from "./TrialHeader.vue?vue&type=script&lang=js"
export * from "./TrialHeader.vue?vue&type=script&lang=js"
import style0 from "./TrialHeader.vue?vue&type=style&index=0&id=661d4b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d4b94",
  null
  
)

export default component.exports